// REG-811/812: report grids (server-side row model) only re-query when their
// own filters or params change, so an edit made elsewhere on the page (the
// merchant side panel) left the row behind it stale until a reload. Writers
// call requestReportGridRefresh() after saving; every mounted ReportGrid
// re-fetches its current block in place.
const EVENT = 'sky:report-grid-refresh';

export function requestReportGridRefresh(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(EVENT));
}

export function onReportGridRefresh(listener: () => void): () => void {
  if (typeof window === 'undefined') return () => {};
  window.addEventListener(EVENT, listener);
  return () => window.removeEventListener(EVENT, listener);
}
